export enum UniquenessCheck {
	NeverUnique,
	UniqueEveryDay,
	UniqueEvery7Days,
	UniqueEvery30Days,
	UniqueEveryYear,
	UniqueAlways,
}
